module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/snow-icon-ffa4f9e7db42670104d48a514e7a028d.svg";